module.exports = __webpack_public_path__ + "static/media/user.08c34a70.jpg";